import React from "react";
import { useTranslation } from "react-i18next";
//
import { useIntakeFormStateValidation } from "./intakeFormState";
// ui
import { MightierLink } from "../../components/MightierLink/MightierLink";
import { Typography } from "../../components/Typography/Typography";
import { MightierButton } from "../../components/MightierButton/MightierButton";

interface NextButtonProps {
  isDisabledOverride?: boolean;
}

export const NextButton = React.memo<NextButtonProps>((props) => {
  const { t } = useTranslation();

  const propsWithDefaults: Required<NextButtonProps> = {
    isDisabledOverride: props.isDisabledOverride ?? false,
  };

  const errors = useIntakeFormStateValidation();

  const isErr = !!errors.length;
  const isDisabled = isErr || propsWithDefaults.isDisabledOverride;

  return (
    <div>
      <div className="mt-10 flex w-full flex-col items-center">
        {errors.includes("consent") ? (
          <>
            <Typography className="text-red">
              {t("intakeFormErrors.consentNotGiven")}
              <MightierLink to="/intake/1">{t("intakeFormErrors.consentNotGiven1")}</MightierLink>
            </Typography>
          </>
        ) : null}
        <MightierButton type="submit" className="" variant={isDisabled ? "disabled" : "primary"}>
          {t("next")}
        </MightierButton>
      </div>
    </div>
  );
});

NextButton.displayName = "NextButton";
